import { supabase } from '../supabase/client';
import { verknuepfeTicketMitEmail } from './ticketLink';

const TICKET_NUMMER_REGEX = /\bT-\d{3,}\b/i;

// Rein & testbar: sucht eine Ticket-Nummer (z.B. "T-0112") im Betreff und
// normalisiert sie auf Großschreibung. null, wenn keine gefunden wird.
export function extrahiereTicketNummer(betreff: string): string | null {
  const match = betreff.match(TICKET_NUMMER_REGEX);
  return match ? match[0].toUpperCase() : null;
}

// Dünner Supabase-Wrapper (Konvention: nicht unit-getestet).
// Findet das Ticket, auf das eine eingehende E-Mail antwortet:
// (a) Ticket-Nummer im Betreff, sonst (b) referenzierte Mail via in_reply_to -> entity_links.
export async function findeTicketFuerReply(
  email: { betreff: string | null; in_reply_to: string | null },
): Promise<{ ticketId: string; ticketNummer: string } | null> {
  try {
    const nr = email.betreff ? extrahiereTicketNummer(email.betreff) : null;
    if (nr) {
      const { data } = await supabase
        .from('tickets').select('id, ticket_nummer').eq('ticket_nummer', nr).maybeSingle();
      if (data) return { ticketId: data.id, ticketNummer: data.ticket_nummer };
    }

    if (email.in_reply_to) {
      const { data: mail } = await supabase
        .from('emails').select('id').eq('message_id', email.in_reply_to).maybeSingle();
      if (mail) {
        const { data: link } = await supabase
          .from('entity_links').select('source_id')
          .eq('source_type', 'ticket').eq('target_type', 'email').eq('link_type', 'quelle')
          .eq('target_id', mail.id).limit(1);
        const ticketId = link?.[0]?.source_id;
        if (ticketId) {
          const { data: ticket } = await supabase
            .from('tickets').select('id, ticket_nummer').eq('id', ticketId).maybeSingle();
          if (ticket) return { ticketId: ticket.id, ticketNummer: ticket.ticket_nummer };
        }
      }
    }

    return null;
  } catch (e) {
    console.warn('findeTicketFuerReply fehlgeschlagen', e);
    return null;
  }
}

// Dünner Supabase-Wrapper (Konvention: nicht unit-getestet).
// Hängt eine weitere E-Mail an ein bestehendes Ticket an: Verknüpfung + interner
// Kommentar mit Auszug + Historien-Eintrag.
export async function haengeEmailAnTicket(
  ticketId: string, emailId: string, mailAuszug: string, benutzerId: string | null,
): Promise<void> {
  await verknuepfeTicketMitEmail(ticketId, emailId);

  await supabase.from('ticket_kommentare').insert({
    ticket_id: ticketId,
    autor_id: benutzerId,
    inhalt: 'Weitere E-Mail zum Vorgang:\n\n' + mailAuszug.substring(0, 800),
    ist_intern: true,
  });

  await supabase.from('ticket_historie').insert({
    ticket_id: ticketId,
    benutzer_id: benutzerId,
    aktion: 'email_angehaengt',
    neuer_wert: 'E-Mail an Ticket angehängt',
  });
}
